import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { Device } from "../../../../../types/types";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../../ui/Separator";
import { Button } from "../../../../../ui/Button";
import { Input } from "../../../../../ui/Input/Input";
import { useOutletContext } from "react-router-dom";
import DeleteDevice from "../../DeleteDevice";

type Props = {
  id: string | undefined;
  currentDevice: Device | undefined;
};

const DeviceSettingsTab = ({ id, currentDevice }: Props) => {
  //const [errors, setErrors] = useState([]);
  const [devices, setDevices] = useOutletContext<[Device[], Function]>();

  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      name: currentDevice?.attributes.name
        ? currentDevice?.attributes.name
        : "",
    },
  });

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  // Обновление информации об участнике
  const [
    { response: saveResponse, isLoading: saveIsLoading, error: saveError },
    doFetchItemSave,
  ] = useFetch(`/administration/devices/devices/${id}`, true);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          name: formData.name,
        },
      },
    });
  };

  const editDevice = (itemSaveResponse: { data: unknown }) => {
    const newFullUserData = itemSaveResponse.data as unknown as Device;
    const currentItemInTableForm = devices?.find((device) => device.id == id)!;
    const newUserData = {
      ...currentItemInTableForm,
      attributes: {
        ...currentItemInTableForm?.attributes,
        name: newFullUserData.attributes.name,
      },
    };
    const withoutCurrentItem = devices?.filter(
      (device) => device.id != currentDevice?.id,
    )!;
    setDevices(
      [...withoutCurrentItem, newUserData].sort(
        (a, b) => Number(a.id) - Number(b.id),
      ),
    );
  };

  useEffect(() => {
    if (!saveResponse) return;
    editDevice(saveResponse);
  }, [saveResponse]);

  return (
    <>
      <div className="pt-8">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ScrollArea>
            <div className="flex flex-col gap-3">
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("name")}*`} />
                  </div>
                )}
              />

              <Separator />
              <div className="mt-8 flex w-full justify-between">
                <Button
                  variant={"destructive"}
                  size={"sm"}
                  type="button"
                  onClick={() => openDeleteModal()}
                >
                  {t("delete")}
                </Button>
                <Button variant={"default"} size={"sm"} type="submit">
                  {t("save")}
                </Button>
              </div>
            </div>
          </ScrollArea>
        </form>
      </div>
      <DeleteDevice
        id={id!}
        isDeleteOpen={isDeleteOpen}
        closeModal={closeDeleteModal}
        devices={devices!}
        setDevices={setDevices}
      />
    </>
  );
};

export default DeviceSettingsTab;
